import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import rightimg from '../assets/images/Header/Arrow Right Up.svg'

const sanitize = (value) => (typeof value === "string" ? value.trim() : "");

// Helper to check if URL is internal
const isInternalUrl = (url) => {
    if (!url || typeof url !== "string") return false;
    const trimmed = url.trim();
    if (trimmed.startsWith("/")) return true;
    if (trimmed.startsWith("mailto:") || trimmed.startsWith("tel:")) return false;
    try {
        const urlObj = new URL(trimmed, window.location.origin);
        return urlObj.origin === window.location.origin;
    } catch {
        return false;
    }
};

const EnquirySection = ({ fields }) => {
    const navigate = useNavigate();
    const sanitizedData = useMemo(() => {
        if (!fields) return null;

        const heading = sanitize(fields.heading || "");
        const description = sanitize(fields.description || "");
        const buttonText = sanitize(fields.button_text || "");
        const buttonUrl = sanitize(fields.button_url || "");

        // Extract image URL from API response - check background_image first, then image
        let imageUrl = null;
        const imageField = fields.background_image || fields.image;
        if (imageField) {
            imageUrl = imageField.url ||
                imageField.sizes?.['2048x2048'] ||
                imageField.sizes?.large ||
                imageField.sizes?.['1536x1536'] ||
                imageField.sizes?.medium_large ||
                null;
        }

        const hasContent = heading || description || (buttonText && buttonUrl) || imageUrl;
        if (!hasContent) return null;

        return {
            heading,
            description,
            buttonText,
            buttonUrl,
            imageUrl,
        };
    }, [fields]);

    if (!sanitizedData) return null;

    const { heading, description, buttonText, buttonUrl, imageUrl } = sanitizedData;

    // Create inline style for background image
    const innerStyle = imageUrl ? {
        backgroundImage: `url("${imageUrl}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    } : {};

    // Debug: Log to help identify the issue
    if (fields && !imageUrl) {
    }

    return (
        <section className="enquiry-section2 container" data-stagger-index="0">
            <div className="enquiry_inner" style={innerStyle}>
                <div className="enquiry-content aos-fade-up" data-stagger-index="1">
                    {heading && <h2>{heading}</h2>}
                    {description && <p>{description}</p>}

                    {buttonText && buttonUrl && (
                        <button
                            className="cta-btn aos-fade-up" data-stagger-index="2"
                            onClick={() => {
                                if (isInternalUrl(buttonUrl)) {
                                    navigate(buttonUrl);
                                } else {
                                    window.location.href = buttonUrl;
                                }
                            }}
                        >
                            {buttonText}{" "}
                            <img src={rightimg} alt="Arrow icon" />
                        </button>
                    )}
                </div>
            </div>
        </section>
    );
};

export default EnquirySection;

